import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/programSubscriptions',
        name: 'programSubscriptions',
        component: () => import("./views/programSubscriptions.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
    {
        path: '/programSubscriptionDetail/:identifier/:ownerIdentifier?',
        name: 'programSubscriptionDetail',
        component: () => import("./views/programSubscriptionDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin],
            hideHelpButton: true
        }
    },
    {
        path: '/programSubscriptionTypes',
        name: 'programSubscriptionTypes',
        component: () => import("./views/programSubscriptionTypes.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
    {
        path: '/programSubscriptionTypeDetail/:identifier',
        name: 'programSubscriptionTypeDetail',
        component: () => import("./views/programSubscriptionTypeDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin],
            hideHelpButton: true
        }
    },
];

export default routes;
